import { get, post, put } from "../utils/request";

export const getListTeam = () => {
  return get('/v1/teams');
}

export const getCurrentTeam = () => {
  return get('/v1/users/me/teams');
}

export const createTeam = (body) => {
  return post('/v1/teams', body);
}

export const assignUsers = (id, body) => {
  return put(`/v1/teams/${id}/assignUsers`, body)
}

export const listTeamServices = (id) => {
  return get(`/v1/teams/${id}/service-entries`);
}

export const assignService = (id, body) => {
  return put(`/v1/teams/${id}/assignServiceEntries`, body);
}

export const listTeamMembers = (id) => {
  return get(`/v1/teams/${id}/users`);
}

export const searchUser = (email) => {
  return get(`/v1/users?email=${email}`);
}